import { FLOW_CREDITS_UPGRADE_PURCHASE_MODAL_RECEIVE } from '../constants';

export const flowCreditUpgradePurchaseModal = (
    state = { },
    action
) => {
    switch (action.type) {
        case FLOW_CREDITS_UPGRADE_PURCHASE_MODAL_RECEIVE:
            return action.payload;
        default:
            return state;
    }
};
